export interface UISettings {
  mode: 'skeuomorphic' | 'minimal';
  scale: number;
  showDebugPanel: boolean;
}

const STORAGE_KEY = 'settings:ui';

function defaultSettings(): UISettings {
  return { mode: 'skeuomorphic', scale: 1, showDebugPanel: false };
}

export class UISettingsManager {
  private settings: UISettings;

  constructor() {
    this.settings = this.loadFromStorage();
  }

  getSettings(): UISettings {
    return { ...this.settings };
  }

  updateSettings(partial: Partial<UISettings>): void {
    this.settings = { ...this.settings, ...partial };
    this.saveToStorage(this.settings);
  }

  resetSettings(): void {
    this.settings = defaultSettings();
    this.saveToStorage(this.settings);
  }

  private loadFromStorage(): UISettings {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultSettings();
      const parsed = JSON.parse(raw);
      const defaults = defaultSettings();
      return {
        mode: (parsed.mode === 'skeuomorphic' || parsed.mode === 'minimal') ? parsed.mode : defaults.mode,
        scale: (typeof parsed.scale === 'number' && parsed.scale > 0) ? parsed.scale : defaults.scale,
        showDebugPanel: typeof parsed.showDebugPanel === 'boolean' ? parsed.showDebugPanel : defaults.showDebugPanel,
      };
    } catch {
      return defaultSettings();
    }
  }

  private saveToStorage(settings: UISettings): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {
    }
  }
}
